import { theme } from '@/theme'

type TSpinnerProps = {
	size?: number
	ringWidth?: number
	color?:
		| Exclude<
				keyof typeof theme.colors,
				| 'qr-color-scheme-1'
				| 'qr-color-scheme-2'
				| 'qr-color-scheme-3'
				| 'qr-color-scheme-4'
				| 'qr-color-scheme-5'
				| 'qr-color-scheme-6'
				| 'qr-color-scheme-7'
		  >
		| string
	className?: string
}

export const Spinner = ({
	size = 24,
	color = 'blue',
	ringWidth = 4,
	className,
	...rest
}: TSpinnerProps) => {
	// @ts-expect-error if color is not a theme value, it is used as actual value
	const colorValue = theme?.colors?.[color] || color

	// SVG space is 24x24, stroke scales relatively
	const viewBoxSize = 24
	const radius = (viewBoxSize - ringWidth) / 2
	const circumference = 2 * Math.PI * radius
	const center = viewBoxSize / 2

	return (
		<svg
			width={size}
			height={size}
			viewBox={`0 0 ${viewBoxSize} ${viewBoxSize}`}
			stroke={colorValue}
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			{...rest}
		>
			<style>
				{`@keyframes spinner-dash {
					0% { stroke-dasharray: 0, ${circumference}; stroke-dashoffset: 0; }
					50% { stroke-dasharray: ${circumference * 0.5}, ${circumference}; stroke-dashoffset: ${-circumference * 0.25}; }
					100% { stroke-dasharray: ${circumference}, ${circumference}; stroke-dashoffset: ${-circumference}; }
				}`}
			</style>
			<circle
				cx={center}
				cy={center}
				r={radius}
				fill="none"
				strokeWidth={ringWidth}
				strokeLinecap="round"
				style={{
					animation: 'spinner-dash 1s linear infinite',
				}}
			/>
		</svg>
	)
}
